<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div class="record-image" *ngIf="images && images.length > 0">
  <epg-image-slider
    [images]="images"
    [imageFormat]="imageFormat!"
    [imageHeightInPx]="80"
    [imageWidthInPx]="120"
    [respectOriginalAspectRatio]="respectOriginalAspectRatio"
    [disableLightBox]="disableLightBox"
    [displayBorder]="true"
  ></epg-image-slider>
</div>
